module.exports = __webpack_public_path__ + "media/images/ShoeRed-fe9d205b.svg";